import axios from 'axios'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import DeliveryConfirmationModal from './modals/DeliveryConfirmationModal.vue'
import RaiseLockerIssueModal from './modals/RaiseLockerIssueModal.vue'
import ChangeLockerButton from './buttons/ChangeLockerButton.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import ModalMixin from '@/mixins/ModalMixin.js'
import AutoConfirmCountdown from '@/vcs/_shared/auto-confirm-countdown/AutoConfirmCountdown.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

const filterOutCpuByBoxId = (cpus, boxId) => {
  return cpus.filter((cpu) => {
    return _.map(cpu.boxes, 'id').indexOf(boxId) != -1
  })[0]
}

export default {
  name: 'DeliveryConfirmation',
  components: { CpuWireframe, ChangeLockerButton, AutoConfirmCountdown },
  mixins: [ModalMixin],
  data: function () {
    return {
      DeliveryConfirmationModal,
      selectedCpu: null,
      boxId: '',
      filterOutCpuByBoxId
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.boxId = window.localStorage.getItem('box_id')
    this.selectedCpu = this.filterOutCpuByBoxId(this.cp.units, this.boxId)
    eventBus.$emit('refresh-token-via-websockets')
  },

  methods: {
    complete() {
      // if (this.$dev) {
      //   this.$unblockUI()
      //   this.openDeliveryConfirmationModal('223344')
      //   // this.openCloseLockerPromptModal(this.$t('CLOSE_LOCKER_MESSAGE'), this.complete);
      //   return
      // }

      this.$blockUI()
      let token = window.localStorage.getItem('delivery_request_token')
      axios({
        method: 'put',
        url: `/delivery_requests/${this.$route.params.id}/complete`,
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        }
      })
        .then((response) => {
          this.openDeliveryConfirmationModal(response.data.shortUrlKey)
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          if (errorCode == 'dr:7') {
            this.openCloseLockerPromptModal(
              this.$t('CLOSE_LOCKER_MESSAGE'),
              this.complete
            )
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    openDeliveryConfirmationModal(shortUrlKey) {
      this.$store.commit('modal/open', {
        cmp: DeliveryConfirmationModal,
        size: 'full',
        data: { shortUrlKey }
      })
    },
    openRaiseLockerIssueModal() {
      this.$store.commit('modal/open', {
        cmp: RaiseLockerIssueModal,
        size: 'full',
        callback: this.onBoxAssigned
      })
    },
    onBoxAssigned(boxId) {
      // INFO: CALLBACK DLA 2 FUNKCJI
      // New box comes
      this.boxId = boxId
      // We recalculate cpu
      this.selectedCpu = this.filterOutCpuByBoxId(this.cp.units, boxId)
    },
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    }
  }
}
